import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U2202, { U2202ROLES } from "./U2202";
import U2202ConnectedUserList from "./components/U2202ConnectedUserList";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U2202Routes: RouteObject[] = [
  {
    path: "U2202",
    element: <U2000RequireRole allowedRoles={[U2202ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U2202 />,
        children: [{ index: true, element: <U2202ConnectedUserList /> }],
      },
    ],
  },
];

export default U2202Routes;
